module.exports = __webpack_public_path__ + "static/media/rectangle-19.7ad15458.svg";